import React from "react";

import { faRepeat } from "@performyard/fontawesome/pro-solid-svg-icons";
import { Icon, Tooltip } from "@performyard/py-components";

export type RecurringSeriesTooltipInfo = {
	name: string;
	schedule: string;
	isEnded: boolean;
};

type MeetingRecurringIconProps = {
	series: RecurringSeriesTooltipInfo;
};

/**
 * The recurring marker beside a visible series meeting's name. Hover reveals the
 * series name and cadence; naturally finished series are labeled as ended.
 */
const MeetingRecurringIcon = ({ series }: MeetingRecurringIconProps): React.ReactElement => {
	const tooltip = (
		<div className="flex flex-col">
			<span className="font-semibold">{series.name}</span>
			<span>{series.isEnded ? `${series.schedule} · Series Ended` : series.schedule}</span>
		</div>
	);

	return (
		<Tooltip content={tooltip} placement="top">
			<div className="flex h-4 w-4 shrink-0 items-center justify-center" data-testid="meeting-recurring-icon">
				<Icon icon={faRepeat} size={16} color="primary-5" />
			</div>
		</Tooltip>
	);
};

export default MeetingRecurringIcon;
